import React from 'react';
import { Button } from '@/components/ui/button';
import { FileText, Download } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminSecurityDocuments = () => {
  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
      <h3 className="text-xl font-bold text-white mb-4 flex items-center space-x-2">
        <FileText className="w-5 h-5" />
        <span>Security Documentation</span>
      </h3>
      
      <p className="text-sm text-gray-400 mb-6">
        Internal security documentation for Coalition cyber insurance application and compliance purposes.
      </p>

      <div className="space-y-3">
        <Button
          onClick={() => window.open(`${BACKEND_URL}/api/documents/security/download-all?format=pdf`, '_blank')}
          className="w-full bg-emerald-600 hover:bg-emerald-700 text-white flex items-center justify-center space-x-2"
        >
          <Download className="w-4 h-4" />
          <span>Download All Documents (PDF - 426 KB)</span>
        </Button>

        <Button
          onClick={() => window.open(`${BACKEND_URL}/api/documents/security/download-all?format=both`, '_blank')}
          variant="outline"
          className="w-full border-gray-600 text-gray-300 hover:bg-gray-700 hover:text-white flex items-center justify-center space-x-2"
        >
          <Download className="w-4 h-4" />
          <span>Download All (PDF + Markdown)</span>
        </Button>
      </div>

      <div className="mt-4 p-3 bg-gray-900 rounded-lg">
        <p className="text-xs text-gray-400 mb-2">📄 Included documents:</p>
        <ul className="text-xs text-gray-500 space-y-1">
          <li>• Security Features Summary</li>
          <li>• Technical Architecture Diagram</li>
          <li>• Data Flow Diagram</li>
          <li>• Incident Response Plan</li>
          <li>• Data Retention Policy</li>
          <li>• Third-Party Vendors</li>
          <li>• Employee Access Policy</li>
          <li>• Backup & Recovery Plan</li>
        </ul>
      </div>

      <div className="mt-4 p-3 bg-blue-900/20 border border-blue-800/30 rounded-lg">
        <p className="text-xs text-blue-300">
          💡 <strong>For Coalition Application:</strong> Download PDFs, fill in placeholders ([Your Company Name], [Owner Name], etc.), and submit via their portal.
        </p>
      </div>
    </div>
  );
};

export default AdminSecurityDocuments;
